var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1783_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0.0864258H9C3.96 0.0864258 0 4.04643 0 9.08643V27.0864C0 32.1264 3.96 36.0864 9 36.0864H27C32.04 36.0864 36 32.1264 36 27.0864V9.08643C36 4.04643 32.04 0.0864258 27 0.0864258ZM32.4 27.0864C32.4 30.1464 30.06 32.4864 27 32.4864H9C5.94 32.4864 3.6 30.1464 3.6 27.0864V9.08643C3.6 6.02643 5.94 3.68643 9 3.68643H27C30.06 3.68643 32.4 6.02643 32.4 9.08643V27.0864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.08643C12.96 9.08643 9 13.0464 9 18.0864C9 23.1264 12.96 27.0864 18 27.0864C23.04 27.0864 27 23.1264 27 18.0864C27 13.0464 23.04 9.08643 18 9.08643ZM18 23.4864C14.94 23.4864 12.6 21.1464 12.6 18.0864C12.6 15.0264 14.94 12.6864 18 12.6864C21.06 12.6864 23.4 15.0264 23.4 18.0864C23.4 21.1464 21.06 23.4864 18 23.4864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9992 10.8866C27.9933 10.8866 28.7992 10.0807 28.7992 9.08662C28.7992 8.09251 27.9933 7.28662 26.9992 7.28662C26.0051 7.28662 25.1992 8.09251 25.1992 9.08662C25.1992 10.0807 26.0051 10.8866 26.9992 10.8866Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1783_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.0864258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIns);
export default __webpack_public_path__ + "static/media/ins.80757a11600f936a20edafb334ae8a45.svg";
export { ForwardRef as ReactComponent };